import api from 'api';

import { defaultPagination } from './general';

type GetQrCodeType = {id: number | string}

export const listQrCode = async (params) => api().get('/qr_code', { params: { ...defaultPagination, ...params } });

export const getQrCode = async ({ id }:GetQrCodeType) => api().get(`/qr_code/${id}`);

export const createQrCode = async ({ data }) => api().post('/qr_code', data);
